import "./Loading.css"
const Loading = (props) => {
    let message = props.message;

    return (
        <div className="overlay">
            <div className="custom-loader"></div>
            {message && <p className="loading-text">{message}</p>}
        </div>
    )
}
export default Loading